import { render, staticRenderFns } from "./ReportsModalBase.vue?vue&type=template&id=8519fac0&"
import script from "./ReportsModalBase.vue?vue&type=script&lang=js&"
export * from "./ReportsModalBase.vue?vue&type=script&lang=js&"
import style0 from "./ReportsModalBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports